// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { crab as _crab } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the crab chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 44
 * Chain Name: Crab Network
 * Default Block Explorer: https://crab-scan.darwinia.network
 * Default RPC URL: https://crab-rpc.darwinia.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { crab } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: crab,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const crab = createCommon({
	..._crab,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
